import styles from './AiSparkle.module.scss';

// Arkestro "AI / Intelligence" sparkle — the SINGLE source for the AI glyph shown next to the
// AI-driven methods (Intelligent Counter Offer, Smart Baseline Method) wherever they appear
// (method modal + toolbar selectors), and beside AI figures in the Suggested Price info drawer.
// 4-point concave sparkle.
interface AiSparkleProps {
  size?: number;
  /**
   * `brand` paints the AI-method orange this glyph has always used. `inherit` takes the
   * surrounding text colour instead, for surfaces that tint their own icons — e.g. the info
   * drawer's blue icon tiles. A prop rather than a caller-supplied class so the colour never
   * depends on which stylesheet happens to load last.
   */
  tone?: 'brand' | 'inherit';
}

export const AiSparkle = ({ size = 13, tone = 'brand' }: AiSparkleProps) => (
  <svg
    aria-hidden
    className={tone === 'brand' ? styles.iconBrand : styles.iconInherit}
    focusable='false'
    height={size}
    viewBox='0 0 24 24'
    width={size}
  >
    {/* Main 4-point sparkle (lower-right) + a smaller one (upper-left) — the classic ✨. */}
    <path d='M16 6 C16 10.5 19.5 14 24 14 C19.5 14 16 17.5 16 22 C16 17.5 12.5 14 8 14 C12.5 14 16 10.5 16 6Z' />
    <path d='M6.5 2 C6.5 4 8.5 6 10.5 6 C8.5 6 6.5 8 6.5 10 C6.5 8 4.5 6 2.5 6 C4.5 6 6.5 4 6.5 2Z' />
  </svg>
);
